import { ISelectPopverOptions } from "../../components/common/CustomPopover/CustomPopover";


export const WORKOUT_FREQUENCY_OPTIONS = [
    { displayValue: '1', internalValue: 1 },
    { displayValue: '2', internalValue: 2 },
    { displayValue: '3', internalValue: 3 },
    { displayValue: '4', internalValue: 4 },
    { displayValue: '5', internalValue: 5 },
    { displayValue: '6', internalValue: 6 },
    { displayValue: '7', internalValue: 7 },
];

export const LEVEL_OPTIONS = [
    { displayValue: 'Beginner', internalValue: 'BEGINNER' },
    { displayValue: 'Intermediate', internalValue: 'INTERMEDIATE' },
    { displayValue: 'Advanced', internalValue: 'ADVANCED' }
];

export const FITNESS_GOAL = [
    { displayValue: 'Lose Weight', internalValue: 1 },
]

export const DAYS_OF_WEEK = [
    { displayValue: 'Monday', internalValue: 0 },
    { displayValue: 'Tuesday', internalValue: 1 },
    { displayValue: 'Wednesday', internalValue: 2 },
    { displayValue: 'Thursday', internalValue: 3 },
    { displayValue: 'Friday', internalValue: 4 },
    { displayValue: 'Saturday', internalValue: 5 },
    { displayValue: 'Sunday', internalValue: 6 }
]

export const WORKOUT_PHASE_TYPES = {
    WARMUP: 'WARMUP',
    WORKOUT: 'WORKOUT',
    COOLDOWN: 'COOLDOWN'
};

export const WORKOUT_PHASES = [
    WORKOUT_PHASE_TYPES.WARMUP,
    WORKOUT_PHASE_TYPES.WORKOUT,
    WORKOUT_PHASE_TYPES.COOLDOWN
];

export const WORKOUT_LABEL = {
    [WORKOUT_PHASE_TYPES.WARMUP]: 'Warmup',
    [WORKOUT_PHASE_TYPES.WORKOUT]: 'Main Workout',
    [WORKOUT_PHASE_TYPES.COOLDOWN]: 'Cooldown'
};

export const GENDER = [
    { displayValue: 'Male', internalValue: 'MALE' },
    { displayValue: 'Female', internalValue: 'FEMALE' },
    { displayValue: 'Others', internalValue: 'OTHERS' }
]

export const EQUIPMENT = [
    { displayValue: 'Yes', internalValue: 2 },
    { displayValue: 'No', internalValue: 1 }
]

export const WORKOUT_FORMAT = [
    { displayValue: 'SnC', internalValue: 'SnC' },
    // { displayValue: 'Yoga', internalValue: 'yoga' },
]

export enum WORKOUT_FOCUS {
    UpperBody = "Upper Body",
    FullBody = "Full Body",
    LowerBody = "Lower Body",
    SimpleWorkouts = "Simple Workouts",
    RestDay = "Rest Day"
}

export const WORKOUT_FOCUS_TYPE: ISelectPopverOptions[] = [
    { displayValue: WORKOUT_FOCUS.UpperBody, internalValue: WORKOUT_FOCUS.UpperBody },
    { displayValue: WORKOUT_FOCUS.FullBody, internalValue: WORKOUT_FOCUS.FullBody },
    { displayValue: WORKOUT_FOCUS.LowerBody, internalValue: WORKOUT_FOCUS.LowerBody },
    { displayValue: WORKOUT_FOCUS.SimpleWorkouts, internalValue: WORKOUT_FOCUS.SimpleWorkouts },
    { displayValue: WORKOUT_FOCUS.RestDay, internalValue: WORKOUT_FOCUS.RestDay }
]

// export const WORKOUT_TYPES = {
//     [WORKOUT_PHASE_TYPES.WARMUP]: [
//         { displayValue: 'Warmup', internalValue: 'WARMUP' },
//         { displayValue: 'Superset', internalValue: 'SUPERSET' }
//     ],

//     [WORKOUT_PHASE_TYPES.WORKOUT]: [
//         { displayValue: 'For Time', internalValue: 'FOR_TIME' },
//         { displayValue: 'For Reps', internalValue: 'For Reps' },
//         { displayValue: 'Ladder', internalValue: 'LADDER' },
//         { displayValue: 'AMRAP', internalValue: 'AMRAP' },
//         { displayValue: 'EMOM', internalValue: 'EMOM' }
//     ],

//     [WORKOUT_PHASE_TYPES.COOLDOWN]: [
//         { displayValue: 'Cooldown', internalValue: 'COOLDOWN' },
//         { displayValue: 'Superset', internalValue: 'SUPERSET' }
//     ]
// }

// export const DEFAULT_WORKOUT_TYPE = {
//     [WORKOUT_PHASE_TYPES.WARMUP]: WORKOUT_TYPES[WORKOUT_PHASE_TYPES.WARMUP][0].internalValue,

//     [WORKOUT_PHASE_TYPES.WORKOUT]: WORKOUT_TYPES[WORKOUT_PHASE_TYPES.WORKOUT][0].internalValue,

//     [WORKOUT_PHASE_TYPES.COOLDOWN]: WORKOUT_TYPES[WORKOUT_PHASE_TYPES.COOLDOWN][0].internalValue
// }

export const WORKOUT_TYPES = [
    { displayValue: 'AMRAP', internalValue: 'AMRAP' },
    { displayValue: 'Circuit', internalValue: 'CIRCUIT' },
    { displayValue: 'Giant', internalValue: 'GIANT' },
    { displayValue: 'Ladder', internalValue: 'LADDER' },
    { displayValue: 'Straight', internalValue: 'STRAIGHT' },
    { displayValue: 'Super', internalValue: 'SUPER' }
]


export enum STATE_VALUES {
    LIVE = "LIVE",
    DRAFT = "DRAFT"
}